import { autoinject } from 'aurelia-framework';
import { MooringArticleCategoryType } from 'models/mooring/MooringArticleCategoryType';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class MooringArticleCategoryTypeService extends BaseApiService<MooringArticleCategoryType> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, MooringArticleCategoryType);
  }
}
